<template>
  <div class="welcome">
    <div class="welcome-messgae">
      <p>Hello, {{ userName }}.</p>
      <p style="margin-left: 30px;">Welcome to Limosa!</p>
    </div>
    <div class="welcome-icon">
      <svg-icon class="icons" icon-class="aircraft"/>
      <svg-icon class="icons" icon-class="trucks"/>
      <svg-icon class="icons" icon-class="network"/>
      <svg-icon style="width: 110px;" class="icons" icon-class="072-invoice"/>
    </div>
  </div>
</template>
<script>
import { getName } from '@/utils/auth'
export default {
  data () {
    return {
      userName: getName()
    }
  }
}
</script>
<style scoped lang="scss">
.welcome {
  padding: 90px 180px;
  height: 100%;
  background-color: rgb(195, 211, 232);
  background-image: linear-gradient(to bottom, rgb(240, 243, 247), rgb(195, 211, 232));
  .welcome-messgae {
    font-size: 26px;
    font-weight: 600;
    padding: 60px 0 160px 120px;
    border-bottom: 3px solid #fff;
  }
  .welcome-icon {
    margin-top: 20px;
    text-align: center;
    position: relative;
    white-space: nowrap;
  }
  .icons {
    width: 150px;
    height: 150px;
    margin: 0 20px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
